<template>
  <section>
    <top-menu/>

    <section>
      <page-header :headerName="isEdit ? 'Editar liberação de funcionalidade' : 'Nova liberação de funcionalidade'" :showBtn="false"
                   :btnName="''" :btnRoute="''" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">

                <feature-window-tabs :current="'windows'"/>

                <!-- Encerrada ou cancelada nao liga nem desliga mais nada: a tela
                     abre para consulta, sem o botao de salvar. -->
                <p class="fc-notice" v-if="isEdit && locked">
                  Esta liberação está {{ status === 'Cancelled' ? 'cancelada' : 'encerrada' }} e não pode
                  mais ser editada.
                </p>

                <p class="fc-note">
                  A funcionalidade é ligada para as empresas escolhidas e
                  <b>desligada automaticamente</b> no fim do período. Empresas que já
                  possuem a funcionalidade não são alteradas e não perdem o acesso
                  no fim.
                </p>

                <div class="fc-dates">
                  <div>
                    <label class="fc-label">Início</label>
                    <input v-model="startsAt" type="date" class="form-control" :disabled="startLocked">
                    <!-- A liberacao ja comecou: o inicio e historia, e o servidor
                         mantem o que ja estava gravado. -->
                    <p class="fc-hint" v-if="startLocked">Já começou; o início não muda.</p>
                  </div>

                  <div>
                    <label class="fc-label">Fim</label>
                    <input v-model="endsAt" type="date" class="form-control">
                    <!--
                      O servidor empurra o fim para 23:59:59 do dia escolhido.
                      Dizer isso evita a leitura de que "até 30/09" desliga na
                      madrugada do dia 30.
                    -->
                    <p class="fc-hint">A liberação vale até o fim deste dia.</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label class="fc-label">Funcionalidades</label>
                    <p class="fc-hint">
                      {{ featureTypes.length }} selecionada(s). Cada empresa recebe todas;
                      as que ela já possui não são alteradas.
                    </p>
                    <feature-module-picker :options="features" v-model="featureTypes"/>
                  </div>
                </div>

                <div class="row fc-row">
                  <div class="col-md-12">
                    <label class="fc-label">Observação (opcional)</label>
                    <input v-model="notes" type="text" maxlength="500" class="form-control"
                           placeholder="Motivo ou número do ticket">
                  </div>
                </div>

                <hr>

                <div class="row fc-row">
                  <div class="col-md-9">
                    <label class="fc-label">Empresas</label>
                    <input v-model="terms" type="text" class="form-control"
                           placeholder="CNPJ, ID ou nome da empresa (separe múltiplos valores com vírgulas)"
                           @keyup.enter="resolveFromTerms">
                  </div>

                  <!-- Mesmo par de botoes do passo 2 de Avisos e Campanhas
                       (broadcastAudience.vue): Buscar azul e Planilha como
                       <label> com o input de arquivo invisivel por cima. -->
                  <div class="col-md-3">
                    <label class="fc-label">&nbsp;</label>
                    <div class="bc-audience__buttons">
                      <button type="button" class="btn blue" :disabled="resolving"
                              @click="resolveFromTerms">Buscar</button>

                      <label class="btn default bc-audience__upload" title="Carregar planilha">
                        Planilha
                        <input type="file" accept=".csv,.txt" @change="onFile">
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Mesma caixa de aviso do Backoffice V2 (WarningBox: borda
                     warning.main, fundo warning.hover, raio 8px). -->
                <p class="fc-notice">
                  Planilha em CSV ou TXT, identificador na primeira coluna. Para .xlsx,
                  salve como CSV antes.
                  <a href="#" class="fc-notice__link" @click.prevent="downloadTemplate">Baixar modelo</a>
                </p>

                <div class="bc-chips" v-if="selected.length">
                  <span class="bc-chips__count">Empresas selecionadas <b>{{ selected.length }}</b></span>
                  <button type="button" class="bc-chips__clear" @click="clearSelection">Limpar seleção</button>
                </div>

                <!--
                  notFound so e um fato quando TODOS os bancos responderam: o termo
                  pode estar justamente no banco que falhou. Dizer "não encontrada"
                  nesse caso seria afirmar o que nao foi verificado.
                -->
                <div class="fc-warn" v-if="shardsFailed.length">
                  {{ shardsFailed.join(', ') }} não responderam: a busca está incompleta
                  e os termos abaixo podem existir nesses bancos.
                </div>

                <div class="fc-warn" v-if="notFound.length">
                  Sem correspondência: {{ notFound.join(', ') }}
                </div>

                <!-- Encontrada, mas fora do Brasil: a API nao a devolve para
                     selecao. Mesmo aviso de broadcastAudience.vue. -->
                <div class="fc-warn" v-if="notBrazil.length">
                  {{ notBrazil.length }} empresa(s) fora do Brasil não podem receber avisos:
                  {{ notBrazil.map(companyLabel).join(', ') }}
                </div>

                <p class="fc-warn" v-if="searchError">{{ searchError }}</p>

                <company-selection-table :rows="rows" :selected.sync="selected" @remove="remove"/>

                <hr>

                <!--
                  Aviso automatico (nota de versao) para as mesmas empresas. O
                  texto nasce das funcionalidades e datas acima e acompanha as
                  mudancas ate o operador edita-lo; o que se ve na previa e o que
                  vai no comando — o servidor nao gera texto proprio.
                -->
                <div class="row fc-row">
                  <div class="col-md-12">
                    <label class="fc-label">Aviso para as empresas</label>
                    <div class="checkbox inline-block">
                      <input v-model="aviso.enabled" id="fw-aviso" type="checkbox">
                      <label @click="aviso.enabled = !aviso.enabled">Criar aviso automaticamente</label>
                    </div>
                    <p class="fc-hint">
                      Nota de versão para os <b>administradores</b>, no Backoffice e no Web,
                      no mesmo período da liberação. Cancelar a liberação cancela o aviso.
                    </p>
                  </div>
                </div>

                <template v-if="aviso.enabled">
                  <placeholder-chips @insert="insertPlaceholder"/>
                  <div class="row fc-row">
                    <div class="col-md-9">
                      <label class="fc-label">Título</label>
                      <input ref="titleInput" :value="avisoTitle" @input="editTitle($event.target.value)" type="text"
                             class="form-control" :maxlength="titleMax"
                             @focus="lastField = 'title'" @blur="remember('title', $event)">
                    </div>
                  </div>

                  <div class="row fc-row">
                    <div class="col-md-12">
                      <label class="fc-label">
                        Texto
                        <a class="fc-link" v-if="aviso.bodyEdited || aviso.titleEdited" @click="regenerate">
                          Regerar texto
                        </a>
                      </label>
                      <broadcast-editor ref="body" :value="avisoBody" @input="onBodyInput" @user-edit="editBody" @focus="lastField = 'body'"/>
                      <p class="fc-hint" v-if="!aviso.bodyEdited">
                        Escrito a partir das funcionalidades e das datas enquanto você não editar o texto.
                      </p>
                      <p class="fc-warn" v-if="avisoBody.length > bodyMax">
                        O texto passa de {{ bodyMax }} caracteres.
                      </p>
                    </div>
                  </div>

                  <div class="row fc-row">
                    <div class="col-md-12">
                      <div class="checkbox inline-block">
                        <input v-model="aviso.dismissible" id="fw-aviso-dismissible" type="checkbox">
                        <label @click="aviso.dismissible = !aviso.dismissible">
                          Pode ser dispensado pelo usuário
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row fc-row">
                    <div class="col-md-12">
                      <label class="fc-label">Visualização</label>
                      <broadcast-preview :form="previewForm"/>
                    </div>
                  </div>
                </template>

                <p class="fc-warn" v-if="sendError">{{ sendError }}</p>

                <div class="bc-actions">
                  <button type="button" class="btn default"
                          @click="$router.push('/avisos-e-campanhas/liberacoes')">
                    Voltar
                  </button>
                  <!-- O andamento fica NO botao: e ele que o operador acabou de
                       clicar, e o bloco de loading abaixo da tabela ficava fora
                       da vista em lista longa. -->
                  <button type="button" class="btn blue fc-submit" :disabled="!canSend || isLoading"
                          @click="send">
                    <i class="fa fa-spinner spinning" v-if="isLoading"></i>
                    <span v-else>{{ isEdit ? 'Salvar' : 'Liberar' }}</span>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <full-loading v-if="loadingFeatures || loadingWindow"/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from "sweetalert";
import featureWindowTabs from "./featureWindowTabs.vue";
import featureModulePicker from "../../components/default/featureModulePicker.vue";
import { labelsOf, releaseSummary } from "./featureModules";
import companySelectionTable from "../broadcast/companySelectionTable.vue";
import broadcastEditor from "../broadcast/broadcastEditor.vue";
import broadcastPreview from "../broadcast/broadcastPreview.vue";
import placeholderChips from "../broadcast/placeholderChips.vue";
import { insertPlaceholderAt, resolveInsertTarget } from "../broadcast/broadcastPlaceholders";
import {
  BROADCAST_BODY_MAX,
  BROADCAST_COLOR,
  BROADCAST_TITLE_MAX,
  BROADCAST_TYPE,
} from "../broadcast/broadcastEnums";
import { broadcastBody, broadcastTitle } from "./featureWindowBroadcast";
import { isNoCrossToken, requestApiV2 } from "../broadcast/broadcastApiV2Auth";
import { downloadCompanyTemplate, readCompanyTermsFromCsv, splitCompanyTerms } from "../broadcast/broadcastCsv";
import {
  BROADCAST_BY_ID,
  BROADCAST_RESOLVE_COMPANIES,
  FEATURE_WINDOWS,
  FEATURE_WINDOW_BY_ID,
  FEATURE_WINDOW_OPTIONS,
} from "../../../../urlConfig";

/** "2026-09-30T23:59:59-03:00" -> "2026-09-30": a data do jeito que o input date le. */
const dayOf = (value) => String(value || '').slice(0, 10);

export default {
  name: "feature-window-create",
  components: {
    topMenu, pageHeader, fullLoading, featureWindowTabs, companySelectionTable,
    featureModulePicker, broadcastEditor, broadcastPreview, placeholderChips,
  },
  data() {
    return {
      features: [],
      lastField: 'title',
      lastCaret: null,
      loadingFeatures: false,
      loadingWindow: false,
      // Situacao da liberacao em edicao (literais do servidor). Vazia na criacao.
      status: '',
      featureTypes: [],
      startsAt: '',
      endsAt: '',
      notes: '',
      terms: '',
      rows: [],
      selected: [],
      notFound: [],
      notBrazil: [],
      shardsFailed: [],
      searchError: '',
      resolving: false,
      isLoading: false,
      sendError: '',
      titleMax: BROADCAST_TITLE_MAX,
      bodyMax: BROADCAST_BODY_MAX,
      // title/body so valem depois de editados; antes disso o texto e o
      // gerado, e acompanha funcionalidades e datas.
      aviso: {
        enabled: true,
        titleEdited: false,
        title: '',
        bodyEdited: false,
        body: '',
        dismissible: true,
      },
    };
  },
  computed: {
    /** Mesmo componente da criacao: o :id da rota liga o modo edicao (PUT). */
    windowId() {
      return this.$route.params.id || null;
    },
    isEdit() {
      return !!this.windowId;
    },
    locked() {
      return this.status === 'Cancelled' || this.status === 'Ended';
    },
    startLocked() {
      return this.isEdit && this.status !== 'Scheduled';
    },
    avisoTitle() {
      return this.aviso.titleEdited ? this.aviso.title : broadcastTitle(this.endsAt);
    },
    avisoBody() {
      return this.aviso.bodyEdited
        ? this.aviso.body
        : broadcastBody(this.features, this.featureTypes, this.startsAt, this.endsAt);
    },
    /** Mesmo formato do form de Avisos: e o que o broadcast-preview le. */
    previewForm() {
      return {
        type: BROADCAST_TYPE.RELEASE_NOTE,
        title: this.avisoTitle,
        subtitle: '',
        body: this.avisoBody,
        imageUrl: '',
        color: BROADCAST_COLOR.PRIMARY,
        ctaLabel: '',
        ctaUrl: '',
        dismissible: this.aviso.dismissible,
      };
    },
    avisoValid() {
      if (!this.aviso.enabled) return true;
      const title = (this.avisoTitle || '').trim();
      return title.length > 0 && title.length <= BROADCAST_TITLE_MAX &&
        this.avisoBody.length <= BROADCAST_BODY_MAX;
    },
    canSend() {
      return this.featureTypes.length > 0 && !!this.endsAt && this.selected.length > 0 &&
        this.avisoValid && !(this.isEdit && this.locked);
    },
  },
  created() {
    // A edicao compara o aviso gravado com o texto gerado, e o texto gerado
    // precisa da lista de funcionalidades: a janela so e lida depois dela.
    this.loadFeatures().then(() => {
      if (this.isEdit) this.loadWindow();
    });
  },
  methods: {
    companyLabel(row) {
      return row.name || row.cnpj || row.companyId;
    },
    downloadTemplate() {
      downloadCompanyTemplate();
    },
    loadFeatures() {
      this.loadingFeatures = true;

      return requestApiV2('GET', FEATURE_WINDOW_OPTIONS)
        .then((response) => {
          this.features = (response && response.data) || [];
        })
        .catch((error) => {
          // Sem a lista nao ha o que escolher: dizer isso e melhor que um seletor
          // vazio, que parece "nenhuma funcionalidade existe".
          this.features = [];
          this.sendError = this.errorText(error, 'carregar as funcionalidades');
        })
        .then(() => {
          this.loadingFeatures = false;
        });
    },
    /**
     * Preenche a tela com a liberacao gravada: datas, funcionalidades,
     * observacao, empresas e o aviso vinculado.
     */
    loadWindow() {
      this.loadingWindow = true;

      requestApiV2('GET', FEATURE_WINDOW_BY_ID(this.windowId))
        .then((response) => {
          const data = (response && response.data) || {};
          const window = data.window || {};

          this.status = window.status || '';
          this.startsAt = dayOf(window.startsAt);
          this.endsAt = dayOf(window.endsAt);
          this.notes = window.notes || '';
          this.featureTypes = (window.featureTypes || []).slice();

          return Promise.all([
            this.loadCompanies(data.companies || []),
            this.loadAviso(window.broadcastId),
          ]);
        })
        .catch((error) => {
          this.sendError = this.errorText(error, 'carregar a liberação');
        })
        .then(() => {
          this.loadingWindow = false;
        });
    },
    /**
     * O detalhe traz uma linha por empresa x funcionalidade e so o nome. A
     * tabela de selecao precisa da linha completa (CNPJ, codigo), entao os ids
     * passam pela mesma busca da tela — e o resultado e filtrado pelo par
     * banco + id, porque id de empresa se repete entre bancos.
     */
    loadCompanies(rows) {
      const wanted = {};
      rows.forEach((row) => { wanted[this.key(row)] = row; });

      const ids = Object.keys(wanted).map((key) => wanted[key].companyId);
      if (!ids.length) return Promise.resolve();

      return requestApiV2('POST', BROADCAST_RESOLVE_COMPANIES, { terms: ids })
        .then((response) => {
          const found = (((response && response.data) || {}).items || [])
            .filter((row) => wanted[this.key(row)]);
          const foundKeys = found.map(this.key);

          // Empresa que a busca nao devolveu (banco fora do ar) continua na
          // selecao com o que o detalhe sabe: tira-la em silencio a desligaria
          // ao salvar.
          const missing = Object.keys(wanted)
            .filter((key) => foundKeys.indexOf(key) === -1)
            .map((key) => ({
              companyId: wanted[key].companyId,
              contextCode: wanted[key].contextCode,
              name: wanted[key].name || wanted[key].companyId,
            }));

          this.rows = found.concat(missing);
          this.selected = this.rows.slice();
        });
    },
    /**
     * Sem aviso vinculado (ou com o vinculado cancelado) a caixa comeca
     * desmarcada. Com aviso, o texto gravado so e tratado como editado se for
     * diferente do que a tela geraria: assim um aviso nunca editado continua
     * acompanhando as funcionalidades e datas, e um aviso escrito a mao nao e
     * sobrescrito.
     */
    loadAviso(broadcastId) {
      if (!broadcastId) {
        this.aviso.enabled = false;
        return Promise.resolve();
      }

      return requestApiV2('GET', BROADCAST_BY_ID(broadcastId))
        .then((response) => {
          const item = ((response && response.data) || {}).item || {};

          if (item.cancelledAt) {
            this.aviso.enabled = false;
            return;
          }

          const title = item.title || '';
          const body = item.body || '';

          this.aviso.enabled = true;
          this.aviso.dismissible = item.dismissible !== false;
          this.aviso.titleEdited = title !== broadcastTitle(this.endsAt);
          this.aviso.title = title;
          this.aviso.bodyEdited = body !== broadcastBody(this.features, this.featureTypes, this.startsAt, this.endsAt);
          this.aviso.body = body;
        })
        .catch(() => {
          // Sem ler o aviso, a tela nao sabe o texto dele: comeca com o gerado,
          // e salvar atualiza o aviso vinculado com ele.
          this.aviso.enabled = true;
        });
    },
    /**
     * Id de empresa e unico POR BANCO, nao globalmente: a chave precisa do
     * contexto junto, senao duas empresas de bancos diferentes colidem.
     */
    key(row) {
      return row.contextCode + ':' + row.companyId;
    },
    isSelected(row) {
      return this.selected.some((s) => this.key(s) === this.key(row));
    },
    /**
     * Tira a empresa da selecao, da tabela E do campo de busca: se o termo
     * que a trouxe ficasse no campo, o proximo "Buscar" a traria de volta.
     * Mesma regra do passo 2 de Avisos e Campanhas.
     */
    remove(row) {
      const key = this.key(row);
      this.selected = this.selected.filter((item) => this.key(item) !== key);
      this.rows = this.rows.filter((item) => this.key(item) !== key);

      const digits = (value) => String(value || '').replace(/\D/g, '');
      const norm = (value) => String(value || '').trim().toLowerCase();
      const ids = [row.companyId, row.contextCode, row.code, row.name]
        .map(norm)
        .filter((value) => value.length > 0);
      const cnpj = digits(row.cnpj);

      const kept = splitCompanyTerms(this.terms).filter((term) => {
        const t = norm(term);
        if (ids.indexOf(t) !== -1) return false;
        if (cnpj && digits(term) === cnpj) return false;
        return true;
      });
      this.terms = kept.join(', ');
    },
    resolveFromTerms() {
      this.resolve(splitCompanyTerms(this.terms));
    },
    clearSelection() {
      this.selected = [];
    },
    onFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      readCompanyTermsFromCsv(file)
        .then((terms) => {
          if (!terms.length) {
            this.sendError = 'A planilha não tem identificadores na primeira coluna.';
            return;
          }
          this.resolve(terms, true);
        })
        .catch((error) => {
          this.sendError = error.message || 'Falha ao ler a planilha.';
        })
        .then(() => {
          event.target.value = '';
        });
    },
    /**
     * A MESMA rota que Avisos e Campanhas usa. Reaproveitar em vez de criar uma
     * busca propria mantem uma unica regra de casamento por Id, código de
     * contexto, CNPJ, código numérico e nome.
     */
    resolve(terms, autoSelect) {
      if (!terms.length) return;

      this.resolving = true;
      this.sendError = '';
      this.searchError = '';

      requestApiV2('POST', BROADCAST_RESOLVE_COMPANIES, { terms: terms })
        .then((response) => {
          const data = (response && response.data) || {};
          this.rows = data.items || [];
          this.notFound = data.notFound || [];
          this.notBrazil = data.notBrazil || [];
          this.shardsFailed = data.shardsFailed || [];

          if (autoSelect) {
            this.rows.forEach((row) => {
              if (!this.isSelected(row)) this.selected.push(row);
            });
          }
        })
        .catch((error) => {
          this.rows = [];
          this.searchError = this.errorText(error, 'buscar as empresas');
        })
        .then(() => {
          this.resolving = false;
        });
    },
    remember(field, event) {
      this.lastField = field;
      this.lastCaret = event.target.selectionStart;
    },
    insertPlaceholder(token) {
      if (this.lastField === 'body' && this.$refs.body) {
        // Edicao da pessoa: dispara user-edit e congela o texto gerado.
        this.$refs.body.insertAtCursor(token);
        return;
      }
      const active = document.activeElement;
      const activeFieldName = active === this.$refs.titleInput ? 'title' : null;
      const activeCaret = activeFieldName ? active.selectionStart : null;

      const { caret } = resolveInsertTarget(this.lastField, activeFieldName, activeCaret, this.lastCaret);
      const next = insertPlaceholderAt(this.avisoTitle, caret, token);
      this.editTitle(next.text);
      this.lastField = 'title';
      this.lastCaret = next.caret;

      this.$nextTick(() => {
        const input = this.$refs.titleInput;
        if (input) {
          input.focus();
          input.setSelectionRange(next.caret, next.caret);
        }
      });
    },
    editTitle(value) {
      this.aviso.title = value;
      this.aviso.titleEdited = true;
    },
    /**
     * O editor mostra o texto gerado e acompanha cada funcionalidade e data
     * escolhida. So a PRIMEIRA edicao da pessoa congela o texto; a partir dai
     * o que vale e o que ela escreveu (ate "Regerar texto").
     */
    editBody() {
      if (this.aviso.bodyEdited) return;
      this.aviso.body = this.avisoBody;
      this.aviso.bodyEdited = true;
    },
    /** Antes da primeira edicao, o que o Quill devolve e so o texto gerado normalizado: ignora. */
    onBodyInput(markdown) {
      if (this.aviso.bodyEdited) this.aviso.body = markdown;
    },
    regenerate() {
      this.aviso.titleEdited = false;
      this.aviso.bodyEdited = false;
    },
    send() {
      if (!this.canSend || this.isLoading) return;

      const names = labelsOf(this.features, this.featureTypes);
      const avisoLine = this.aviso.enabled
        ? '\n\n+ 1 aviso para ' + this.selected.length + ' empresa(s).'
        : '';

      // Na edicao, quem saiu da selecao perde o acesso na hora; dizer isso antes
      // de salvar e o que separa uma edicao de um cancelamento por engano.
      const confirm = this.isEdit
        ? {
          title: "Salvar a liberação?",
          text: releaseSummary(names, this.selected.length, this.endsAt) +
            "\n\nEmpresas e funcionalidades retiradas perdem o acesso agora; as novas recebem " +
            "no início do período." + avisoLine,
          buttons: ["Voltar", "Salvar"],
        }
        : {
          title: names.length > 1 ? "Liberar as funcionalidades?" : "Liberar a funcionalidade?",
          text: releaseSummary(names, this.selected.length, this.endsAt) + avisoLine,
          buttons: ["Voltar", "Liberar"],
        };

      swal({
        title: confirm.title,
        text: confirm.text,
        icon: "warning",
        buttons: confirm.buttons,
      }).then((confirmed) => {
        if (!confirmed) return;

        this.isLoading = true;
        this.sendError = '';

        const payload = {
          featureTypes: this.featureTypes,
          // Sem data de inicio a API entende "agora", que e o caso comum.
          startsAt: this.startsAt || null,
          endsAt: this.endsAt,
          notes: this.notes || null,
          companies: this.selected.map((row) => ({
            companyId: row.companyId,
            contextCode: row.contextCode,
          })),
          broadcast: this.aviso.enabled
            ? {
              title: this.avisoTitle.trim(),
              body: this.avisoBody,
              dismissible: this.aviso.dismissible,
            }
            : null,
        };

        const request = this.isEdit
          ? requestApiV2('PUT', FEATURE_WINDOW_BY_ID(this.windowId), payload)
          : requestApiV2('POST', FEATURE_WINDOWS, payload);

        request
          .then((response) => {
            const data = (response && response.data) || {};

            // O numero vem do SERVIDOR: e quantas ativacoes (empresa x funcionalidade)
            // os bancos confirmaram, nao quantas empresas foram selecionadas na tela.
            let done = (this.isEdit ? "Liberação salva. " : "Liberação criada. ") +
              (data.activated || 0) + " ativação(ões) feita(s) agora.";

            if (this.isEdit && data.deactivated)
              done += " " + data.deactivated + " desligada(s).";

            // O aviso falhar nao derruba a liberacao; o servidor diz o que
            // aconteceu e o operador precisa ler antes de sair da tela.
            if (data.broadcastWarning) {
              swal("Atenção", done + "\n\n" + data.broadcastWarning, "warning");
            } else {
              swal("Aviso", done, "success");
            }

            this.$router.push('/avisos-e-campanhas/liberacoes');
          })
          .catch((error) => {
            this.sendError = this.errorText(error, this.isEdit ? 'salvar a liberação' : 'criar a liberação');
          })
          .then(() => {
            this.isLoading = false;
          });
      });
    },
    errorText(error, action) {
      const status = error && error.response && error.response.status;

      if (isNoCrossToken(error))
        return 'Saia e entre novamente no Master para autenticar na API v2.';

      if (status === 404)
        return 'Endpoint não encontrado (404). A API ainda não está publicada neste ambiente.';

      if (status === 401 || status === 403)
        return 'Sem permissão (' + status + '). É necessário um usuário operador da plataforma.';

      // Regra de negocio recusada (400): a frase do servidor diz o que corrigir,
      // por exemplo "A data de fim já passou".
      const data = (error && error.response && error.response.data) || {};
      const message = data.message || data.Message;
      if (status === 400 && message) return message;

      return 'Não foi possível ' + action + (status ? ' (' + status + ')' : '') + '.';
    },
  },
};
</script>

<style scoped>
.fc-notice__link { margin-left: 6px; color: #1b59f8; font-weight: 600; text-decoration: underline; }
/* Mesma largura e espaco das datas do aviso (broadcastAudience). O bloco
   inteiro tem a largura do campo: a dica abaixo quebra linha em vez de
   empurrar o campo vizinho. */
.fc-dates { display: flex; flex-wrap: wrap; gap: 0 16px; }
.fc-dates > div { width: 180px; max-width: 100%; }

.fc-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #4e5560;
  margin-bottom: 4px;
}

.fc-hint { font-size: 11px; color: #8f96a3; margin-top: 4px; }

.fc-note { font-size: 12px; color: #4e5560; margin-bottom: 18px; }

.fc-row { margin-top: 14px; }

.fc-link { margin-left: 10px; font-weight: 400; cursor: pointer; }

/* Largura fixa: trocar o texto pelo spinner nao pode encolher o botao. */
.fc-submit { min-width: 96px; }

/* Copiado de broadcastAudience.vue: os dois botoes viram itens iguais do
   flex, mesma altura do input, mesmo raio, sem o deslocamento que o global
   `.filters button` aplica (top: 4px, margin-left: 17px, largura fixa). */
.bc-audience__buttons { display: flex; gap: 8px; align-items: stretch; }
.bc-audience__buttons .btn {
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: static;
  top: 0;
  width: auto;
  height: 34px;
  margin: 0;
  padding: 0 12px;
  border-radius: 4px;
  line-height: 1;
}
.bc-audience__buttons .bc-audience__upload { position: relative; overflow: hidden; }
.bc-audience__upload input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.bc-chips {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 10px 0;
  padding: 10px 14px;
  border: 1px solid #d5d7da;
  border-radius: 6px;
}
.bc-chips__count { font-size: 13px; color: #3a424e; }
.bc-chips__clear {
  position: static;
  top: 0;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: #1b59f8;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

/* 28px acima: sem tabela, Voltar/Liberar ficavam colados em Buscar/Planilha
   e as duas fileiras liam como um tabuleiro. */
.bc-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 28px; padding: 0 0 6px; }
.bc-actions .btn {
  position: static;
  top: 0;
  width: auto;
  min-width: 120px;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  white-space: nowrap;
}

.fc-notice {
  display: flex;
  align-items: center;
  margin: 10px 0 0;
  padding: 8px 12px;
  border: 1px solid #fdd944;
  background: #fff9eb;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #4e5560;
}

.fc-warn {
  background: #fff9eb;
  color: #ffb800;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/featureWindow/featureWindowCreate.vue